import React from "react";
import { useFormikContext } from "formik";
import FormField from "../VendorOnboarding/FormField";

const Step9 = () => {
  const { values } = useFormikContext();

  return (
    <div className="w-full">
      <h3 className="text-[#242424] font-medium mb-2">
        Is there anything else we should be aware of when entering the property?
      </h3>
      <h4 className="text-[#595959] font-medium mb-4">
        This could include things like difficult-to-find entrances, alarms,
        parking instructions, or anything else that would help our technician
        access your home safely and smoothly
      </h4>

      <FormField
        label=""
        name="has_access_info"
        type="radio"
        options={[
          { value: true, label: "Yes" },
          { value: false, label: "No" },
        ]}
      />

      {values?.has_access_info === true && (
        <div className="mt-4">
          <FormField
            label="Tell us more?"
            name="access_instructions"
            type="textarea"
            placeholder="Please provide additional access information..."
            className="min-h-[102px]"
          />
        </div>
      )}
    </div>
  );
};

export default Step9;
